import { FC } from "react";
import ExportJobsWebLayout from "./WebLayout";

const ExportJobs: FC = () => {
  return (
    <div>
      <ExportJobsWebLayout />
    </div>
  );
};

export default ExportJobs;
